/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Warning_Heat_SourceInputs */



/**
* | output |
* | --- |
* | "A heat source outside the radiator (e.g. sunlight, electrical appliance) may distort the calibration" |
*
* @param {Calibration_Temperature_Warning_Heat_SourceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_warning_heat_source = /** @type {((inputs?: Calibration_Temperature_Warning_Heat_SourceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Warning_Heat_SourceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("A heat source outside the radiator (e.g. sunlight, electrical appliance) may distort the calibration")
	return /** @type {LocalizedString} */ ("Une source de chaleur extérieure au radiateur (ex. : soleil, appareil électrique) peut fausser le calibrage")
});